import {
  GOLD_SILVER_RATES,
  GET_INVESTMENT,
  REDEEM_PRODUCTS,
  GET_GOLD_COINS_DATA,
  BUY_GOLD_COINS_CALL,
  START_SELF_TXN,
  REDEEM_ORDER,
  START_TXN,
  GIFT_STATUS
} from "./types";
import {
  GOLD_SILVER_LIVE_PRICES,
  VENDOR_BASE_URL,
  TRANSACTION_BASE_URL,
  MAIN_BALANCE_API,
  GET_SELF_INVESTMENT,
  REDEEM_PRODUCTS_API,
  GET_GOLD_COINS,
  BUY_GOLD_COINS,
  SELF_INVESTMENT_ORDER_API,
  REDEEM_ORDER_API,
  GIFTING_API,
  GIFT_ORDER_STATUS,
  REDEEM_ORDER_STATUS_API,
} from "../../Api/EndPoints";
import { APIClient } from "../../Api/APIClient";
import * as Models from "../../models";

export function getLivePrices(token: any) {
  return (dispatch: (arg0: { type: string }) => void, getState: any) =>
    new Promise((resolve, reject) => {
      dispatch({ type: GOLD_SILVER_RATES });
      const apiClient = APIClient.getInstance();
      if (apiClient) {
        apiClient
          .getGold(VENDOR_BASE_URL + GOLD_SILVER_LIVE_PRICES, token)
          .then((response: any) => {
            let result = response;
            resolve(result);
          })
          .catch((error: any) => {
            let errorMessage = error.message;
            reject(errorMessage);
          });
      }
    });
}

export function getInvestments(phoneNumber: any, token: any) {
  return (dispatch: (arg0: { type: string }) => void, getState: any) =>
    new Promise((resolve, reject) => {
      dispatch({ type: GET_INVESTMENT });
      const apiClient = APIClient.getInstance();
      if (apiClient) {
        apiClient
          .getRequest(TRANSACTION_BASE_URL + GET_SELF_INVESTMENT + phoneNumber, token)
          .then((response: any) => {
            let result = response;
            resolve(result);
          })
          .catch((error: any) => {
            let errorMessage = error.message;
            reject(errorMessage);
          });
      }
    });
}

export function buyGoldCoin(
  req: any,
  token: string
) {
  return (dispatch: (arg0: { type: string }) => void, getState: any) =>
    new Promise((resolve, reject) => {
      dispatch({ type: BUY_GOLD_COINS_CALL });
      const apiClient = APIClient.getInstance();
      if (apiClient) {
        apiClient
          .postData(TRANSACTION_BASE_URL + BUY_GOLD_COINS, JSON.stringify(req), token)
          .then((response: any) => {
            let result = response;
            resolve(result);
          })
          .catch((error: any) => {
            let errorMessage = error.message;
            reject(errorMessage);
          });
      }
    });
}


export function startInvestment(
  req: any,
  token: string
) {
  return (dispatch: (arg0: { type: string }) => void, getState: any) =>
    new Promise((resolve, reject) => {
      dispatch({ type: START_SELF_TXN });
      const apiClient = APIClient.getInstance();
      if (apiClient) {
        apiClient
          .postData(TRANSACTION_BASE_URL + SELF_INVESTMENT_ORDER_API, JSON.stringify(req), token)
          .then((response: any) => {
            let result = response;
            resolve(result);
          })
          .catch((error: any) => {
            let errorMessage = error.message;
            reject(errorMessage);
          });
      }
    });
}

export function giftingAPICall(
  req: any,
  token: string
) {
  return (dispatch: (arg0: { type: string }) => void, getState: any) =>
    new Promise((resolve, reject) => {
      dispatch({ type: START_TXN });
      const apiClient = APIClient.getInstance();
      if (apiClient) {
        apiClient
          .postData(TRANSACTION_BASE_URL + GIFTING_API, JSON.stringify(req), token)
          .then((response: any) => {
            let result = response;
            resolve(result);
          })
          .catch((error: any) => {
            let errorMessage = error.message;
            reject(errorMessage);
          });
      }
    });
}


export function redeemOrderAPICall(
  req: any,
  token: string
) {
  return (dispatch: (arg0: { type: string }) => void, getState: any) =>
    new Promise((resolve, reject) => {
      dispatch({ type: REDEEM_ORDER });
      const apiClient = APIClient.getInstance();
      if (apiClient) {
        apiClient
          .postData(TRANSACTION_BASE_URL + REDEEM_ORDER_API, JSON.stringify(req), token)
          .then((response: any) => {
            let result = response;
            resolve(result);
          })
          .catch((error: any) => {
            let errorMessage = error.message;
            reject(errorMessage);
          });
      }
    });
}







export function getProducts(productType: any, token: any) {
  return (dispatch: (arg0: { type: string }) => void, getState: any) =>
    new Promise((resolve, reject) => {
      dispatch({ type: REDEEM_PRODUCTS });
      const apiClient = APIClient.getInstance();
      if (apiClient) {
        apiClient
          .getRequest(VENDOR_BASE_URL + REDEEM_PRODUCTS_API + productType, token)
          .then((response: any) => {
            let result = response;
            resolve(result);
          })
          .catch((error: any) => {
            let errorMessage = error.message;
            reject(errorMessage);
          });
      }
    });
}

export function getGoldCoins(token: any) {
  return (dispatch: (arg0: { type: string }) => void, getState: any) =>
    new Promise((resolve, reject) => {
      dispatch({ type: GET_GOLD_COINS_DATA });
      const apiClient = APIClient.getInstance();
      if (apiClient) {
        apiClient
          .getRequest(TRANSACTION_BASE_URL + GET_GOLD_COINS, token)
          .then((response: any) => {
            let result = response;
            resolve(result);
          })
          .catch((error: any) => {
            let errorMessage = error.message;
            reject(errorMessage);
          });
      }
    });
}


export function redeemOrderStatus(
  req: any,
  token: string
) {
  return (dispatch: (arg0: { type: string }) => void, getState: any) =>
    new Promise((resolve, reject) => {
      dispatch({ type: REDEEM_ORDER });
      const apiClient = APIClient.getInstance();
      if (apiClient) {
        apiClient
          .postData(TRANSACTION_BASE_URL + REDEEM_ORDER_STATUS_API, JSON.stringify(req), token)
          .then((response: any) => {
            let result = response;
            resolve(result);
          })
          .catch((error: any) => {
            let errorMessage = error.message;
            reject(errorMessage);
          });
      }
    });
}

//Gift status
export function giftingStatusApi(
  req: any,
  token: string
) {
  return (dispatch: (arg0: { type: string }) => void, getState: any) =>
    new Promise((resolve, reject) => {
      dispatch({ type: GIFT_STATUS });
      const apiClient = APIClient.getInstance();
      if (apiClient) {
        apiClient
          .postData(TRANSACTION_BASE_URL + GIFT_ORDER_STATUS, JSON.stringify(req), token)
          .then((response: any) => {
            let result = response;
            resolve(result);
          })
          .catch((error: any) => {
            let errorMessage = error.message;
            reject(errorMessage);
          });
      }
    });
}